import { Component, Input } from '@angular/core';
import { CarouselBreakpoint } from '../../shared/utils/infinite-carousel';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent {

    // Mismos tramos que el "responsive" de owl que reemplaza (0→1, 400→2, 740→3, 940→4, 1140→6),
    // para conservar la misma cantidad de logos visibles por ancho de pantalla. La mecánica del
    // carrusel (autoplay, flechas, breakpoints) ahora vive en <usb-carousel> (ver template).
    brandsCarouselBreakpoints: CarouselBreakpoint[] = [
      { minWidth: 0, items: 1 },
      { minWidth: 400, items: 2 },
      { minWidth: 740, items: 3 },
      { minWidth: 940, items: 4 },
      { minWidth: 1140, items: 6 }
    ];

  @Input() images: any[] = [];

}
